import { generateBaseQueryKeysList } from '@/queries/utils';

export const NOTIFICATIONS_SETTINGS_KEYS = {
  main: 'notifications-settings',
};

export const personalizationQueryKeys = generateBaseQueryKeysList(NOTIFICATIONS_SETTINGS_KEYS.main);

export const personalizationUpdateMutationKey = [NOTIFICATIONS_SETTINGS_KEYS.main, 'update'];

export const personalizationUpdateScope = { id: personalizationUpdateMutationKey.join('.') };
